import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EInvoiceValidatorComponent } from './e-invoice-validator.component';

const routes: Routes = [
  {
    path: '',
    component: EInvoiceValidatorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EInvoiceValidatorComponentRoutingModule {}
